
/* 

----- Axis Basket ----- 
**IMPORTANT** - Until /bronze/basket.js's function has been migrated over to using es6 modules the the basket functionality will be split between this file and basket.js.

- 
*/

// Basket configuration.
// Ajax operation variable name.
const ajaxAction = "operation=";
// Ajax Product id variable name.
const referenceId = "reference=";

// Initialise all basket related functionality.
function initialiseAll() {
    // Suppress default behavour for basket update triggers, preventing buttons / anchors from navigating to another page / submitting the page.
    $('body').on('click', expressSelectors()['basket']['add-trigger'], function(event) { 
        event.preventDefault();
    });
    // Suppress default behavour for update basket forms, basically preventing full page submission.
    $('body').on('submit', expressSelectors()['basket']['add-form'], function(event) {
        event.preventDefault();
    });
    // Add to basket listener.
    addToBasketListener();

    // Listener for when the browser resize's to get the new position.
    $(window).on('resize', () => {
        // Update position.
        setSummaryRecentlyAddedPosition();
    });

    // Update summary position.
    setSummaryRecentlyAddedPosition();
}

// Update summary position.
function setSummaryRecentlyAddedPosition() {
    // Recently added.
    let recentlyAdded = $('[' + expressSelectors()['basket']['summary-recently-added'] + ']');
    // Recently added position.
    let position = 0;
     // Get summary context.
    let summaryContext = $('[' + expressSelectors()['basket']['summary-container'] + ']');
    // If ecommerce mode is disabled.
    if (summaryContext) {
      return 0;
    }
    // If recently added exists.
    if (recentlyAdded) {
      // Only for desktop layout.
      if (currentBreakpoint() >= 3) {
        // Get container position.
        let containerPosition = summaryContext.offset().left;
        // Work out position, first find the right side of the container then deduct the popup's width from that position, adding 1px so the recently added fully overlaps the summary in the header.
        position = ((containerPosition + $('[' + expressSelectors()['basket']['summary-container'] + ']').outerWidth()) - recentlyAdded.outerWidth() + 1);
      }
        
      if (AXISDebug.level() >= 4) {
         AXISDebug.output(1,"Basket: The recently added position has been calculated.", position);
      }
      // Add positioning to DOM element.
      recentlyAdded.css('left', position);
    }
    // Return the position.
    return position;
}
// Add to basket listener used throughout express.
function addToBasketListener() {
  // Trigger the add basket process from further up in the tree ( i.e a table row ).
  $('body').on('click', '[' + expressSelectors()['basket']['add-parent-container'] + ']', function() {
    // Get context.
    let context = $(this);
    // Find add to basket button.
    let button = context.find(expressSelectors()['basket']['add-trigger']);
    // Programmatically trigger click.
    button.trigger('click');
  });
  $('body').on('click', expressSelectors()['basket']['add-trigger'], function (event) {
    // Stop the click event from bubbling up the tree.
    event.stopPropagation()
    // Store context.
    let context = $(this);
    // Form context.
    let form = context.parents('form');
    // Check whether button is disabled if so exit update process.
    if (context.hasClass('disabled') || context.attr('disabled')) {
      AXISDebug.output(2,"Basket update: The basket update button has been disabled exiting update function.");
      // Output error callout.
      AXISInputs.disabledButtons(context);
      return false;
    }
    // Operation.
    let operation = AXISAjax.getOperation(context);
    // Make sure operation is defined.
    if (!operation || operation == undefined) {
      AXISDebug.output(3, "Basket update: No operation defined on submission button.");
      return false;
    }
    // Get the container.
    let container = context.parents('.quantity-container');
    // Fallback.
    if (!container.length) {
      container = context.parents('form');
      if (!container.length) {
        AXISDebug.output(3, "Basket update: Could not find the container for the basket update button.");
        return false;
      }
    }
    // Is this a stockline?
    let isStockline = (container.find('[data-stockline]').length > 0 ? true : false);
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1, "Basket Update: Is this a stockline: " + isStockline);
    }
    // Get input with quantity & product ref.
    let input = container.find('.input-number');
    //The product reference number
    var productReference = input.attr("name");
    //The value in the quantity box
    var quantityValue = input.val();
    //Start the array of the product ID and quantity
    let formElements = "";
    // If adding to the basket then this holds the serialised from variables.
    let items = undefined;
    // Run validation.
    let validate = AXISInputs.validateForm(form);
    // Make sure quantity input is valid ( free text ).
    let isValid = (container.find('.is-invalid-quantity').length > 0 ? false : true);
    // Check if form is valid.
    if (isValid) {
      // If parent form doesnt have class invalid.
      isValid = !context.parents('form').hasClass('is-invalid');
    }

    if (!isValid) {
      if (AXISDebug.level() >= 2) {
        AXISDebug.output(2,"Basket Update: The quantity selector is invalid does the value match a mutiple of the case quantity? is the value 0?");
      }
      return false;
    }

    //Store the parent form
    //If the length of the quantity input is not zero
    if (quantityValue > 0) {
      //Then a buy button with a quantity input has been clicked, set the quantity to the value of the quantity input
      formElements = formElements + productReference + "=" + quantityValue;
      //If the length of the quantity input is zero
    } else {
      //Then the a buy button without a quantity input was clicked, set the quantity to 1
      formElements = formElements + productReference + "=1";
    }

    items = context.parents('form').serialize();

    // Are we on the basket page? 
    let isBasketPage = ($(expressSelectors()['basket']['form']).length > 0 ? true : false);
    // Build post data.
    formElements = operation + (productReference ? "&" + referenceId + productReference : '') + (items ? "&" + items : "") + (isBasketPage ? "&return-basket=true" : "");

    //Call post url function to determine post location.
    var postUrl = AXISAjax.postUrl(context);
    var buttonId = $(this);

    let responseFocus = form.attr(expressSelectors()['ajax']['response-focus-element-id']);
    
    //Call the update basket include page to update with the values entered (formElements)
    AXISAjax.post(postUrl, formElements, 'json', buttonId).then(function (data) {
      // Get response.
      let basketContents = data['data'];

      if ($(buttonId).hasClass('icon')) {
        //Animate the basket icon.
        $(buttonId).addClass('animated drop');
        //Add secondary animation.
        setTimeout(() => {
          $(buttonId).addClass('animated tada');
        }, 500);
        //Clear out the animation classes.
        setTimeout(() => {
          $(buttonId).removeClass('animated tada drop');
        }, 2000);

      }
      // Pass basket update response to semi generic function to update the DOM.
      updateDOM(basketContents);

      // Think of this as a shim.... in the ideal world this code wouldn't have to exist but would just run through the common update handler within axis-ajax.js 820194.
      if (basketContents.hasOwnProperty('updates')) {
        // Strip out just the updates that need to be run passed the update handler.
        let updates = {};
        updates['updates'] = basketContents['updates'];
        AXISAjax.update(context, updates);
      }

      // If we're on the basket page ( i.e quick order form )
      if (isBasketPage && basketContents.hasOwnProperty('basketContent')) {
        // Get the content container on the basket page.
        let basketContentContainer = $(expressSelectors()['basket']['basket-page-content-container']);
        // If content container found.
        if (basketContentContainer.length) {
          // Update DOM.
          basketContentContainer.html(basketContents['basketContent']);
          // Re-initialise.

          //tableTextEqualiser.initialise($('#basket-table .text-container'));

          AXISAjax.reInitialiseJs(basketContentContainer);

          
        } else {
          AXISDebug.output(2,"Axis Basket: Could not find content container to update");
        }

        // Find basket table.
        let basketTable = $('#basket-table');
        if (basketTable.length && !responseFocus) {
          // Find last item.
          let lastItem = basketTable.find('tbody tr').last();
          // Scroll to last item.
          if (lastItem) {
            Foundation.SmoothScroll.scrollToLoc(lastItem, {threshold: 50,offset: (getHeaderSize() + 100)});
          }
        } else if (responseFocus) {
          // Focus element context.
          let focusElement = $('#' + responseFocus);
          // If not in view then scroll into view.
          if (!getViewPort(focusElement)) {
            // Set timeout to clear any animations.
            setTimeout(() => {
              Foundation.SmoothScroll.scrollToLoc(focusElement, {threshold: 50,offset: (getHeaderSize() + 100)});
            });
          } 
          // // Focus on element.
          focusElement.trigger('focus');
        }
        let modals = AXISModals.activeModals();
        setTimeout(function () {
          if (modals.length > 0) {
            // Check if any modals are active.
            AXISModals.modalClose();
          }
        }, (form.attr(expressSelectors()['ajax']['content-blocker-delay']) ? form.attr(expressSelectors()['ajax']['content-blocker-delay']) : 0));
       
      }
    });
  });
}

function toggleRecentlyUpdated() {
    // Get summary container.
    let container = $('[' + expressSelectors()['basket']['summary-container'] + ']');
    // If the container doesn't exist then exit.
    if (!container) {
        return false;
    }
    // Get pause.
    let pause = container.attr(expressSelectors()['basket']['recently-updated-pause']);
    // Default.
    if (!pause) {
        pause = 4000;
    }
    // Holds timer.
    let timer = 0;
    // Get recently add context.
    let context = $('[' + expressSelectors()['basket']['summary-recently-added'] + ']');
    // Open modal.
    let isActive = openRecentlyUpdated();
    if (isActive) {
      // If mouse enters the recently updated container then stop the timer.
      context.on('mouseenter', function() {
        // Stop timer.
        clearInterval(timer);
      });
      // If mouse leaves the recently update container then start the timer again.
      context.on('mouseleave', function() {
        // Reset timer back to 0.
        timer = 0;
        // Start timer.
        startTimer();
      })
      // Start close timer.
      startTimer();
    } else {
        AXISDebug.output(3,"Basket: Failed to open recently updated", container);
        return false;
    }

     // Set interval for when recently added gets closed.
    function startTimer() {
      return timer = setInterval(function() {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Basket: Closing recently added.");
        }
        // De-activate the recently added popup.
        isActive = closeRecentlyUpdated()
        // Stop timer.
        clearInterval(timer);
        // Remove mouse listeners.
        context.off('mouseenter mouseleave');
        return true;
      }, pause);
    }
    
}
// Open recently updated popup.
function openRecentlyUpdated() {
    // Get summary container.
    let container = $('[' + expressSelectors()['basket']['summary-container'] + ']');
    // Enable active state.
    container.addClass('active');
    if (container.hasClass('active')) {
        return true;
    } else {
        return false;
    }
}


// New Generic basket update mechanism using Generic form callback mechanism.
function updateHeaderSummary(data) {
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"Basket: Attempting to update the header summary.", data);
  }
  if (!data) {
    AXISDebug.output(3,"Basket: Could not update header summary due to no update data provided.", data);
    return false;
  }
  // Get Container Id.
  let containerId = data['id'];
  if (!containerId) {
    AXISDebug.output(3,"Basket: Could not update header summary due to no container id provided", id);
    return false;
  }
  // Get container element context.
  let container = $('#' + containerId);
  if (!container.length) {
    AXISDebug.output(3,"Basket: Could not update header due to no container not present in the DOM", id);
    return false;
  }
  // Get summary container context.
  let summaryContainer = container.find('[' + expressSelectors()['basket']['summary-container'] + ']');
  if (!summaryContainer.length) {
    AXISDebug.output(3,"Basket: Could not find header summary container in DOM", container);
    return false;
  }
  // Get Update data.
  let update = data['update'][0];
  // Does this update container the basket's item count?
  if (update.hasOwnProperty('item-count')) {
    // Check DOM for item count elements.
    let elements = $('[' + expressSelectors()['basket']['item-count'] + ']');
    if (elements.length) {
      elements.html(update['item-count']);
    }
  }
  // Does this update container basket total?
  if (update.hasOwnProperty('total-value')) {
    // Check DOM for basket total.
    let elements = container.find('[' + expressSelectors()['basket']['total-value'] + ']');
    if (elements.length) {
      elements.html(update['total-value']);
    }
  }
  // Find notification containers.
  let notificationContainers = container.find('[' + expressSelectors()['basket']['summary-notifications-container'] + ']');
  // Output notifications.
  if (update.hasOwnProperty('notifications')) {
    let notifications = update['notifications'];
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Basket: Notifications detected", notifications);
    }    
    if (notificationContainers.length) {
      // Clear previous notifications.
      notificationContainers.empty();
      // Reset summary severity state.
      summaryContainer.removeClass('alert warning');
      // Loop over notifications.
      notifications.forEach(notification => {
          if (notification.hasOwnProperty('message')) {
            notificationContainers.append(notification['message']);
          }
          if (notification.hasOwnProperty('severity')) {
            // Get severity.
            let severity = notification['severity'];
            // Assign appropriate classes.
            switch (severity) {
              case "warning":
                summaryContainer.addClass('warning');
                break;
              case "alert":
                // Check if any previous notifications has been assigned if they're not as serious then remove them.
                if (summaryContainer.hasClass('warning')) {
                  summaryContainer.removeClass('warning');
                }
                summaryContainer.addClass('alert');
                break;
              default:
                AXISDebug.output(3,"Basket: Currently do not support that level of severity.", severity);
            }
          }
      });


      // TODO: Initialise notifications.
      notificationContainers.each(function() {
        // Container context.
        let notificationContainer = $(this);
        // What sort of notifications are we initialising?
        let type = notificationContainer.attr(expressSelectors()['basket']['summary-notification-type']);
        if (!type) {
          AXISDebug.output(2,"Basket: No notification type defined defaulting to text");
          type = "text";
        }
        // Find Notifications.
        let notifications = notificationContainer.find('[data-notification]');
        

        switch (type) {
          case "tooltip": 
            notifications.each(function() {
              // Notification context.
              let notification = $(this);
              notification.wrap('<div class="tooltip-content"></div>');
              notification.wrap('<div class="summary-message-container"></div>');
              notification.wrap('<div class="content-container"></div>');
            
              // Find tooltip trigger.
              let trigger = container.find('[data-desktop-summary]');
              if (trigger.length) {

                if (trigger.attr('data-tooltip') == undefined) {
                  summaryContainer.addClass('tooltip-container');
                  trigger.attr('data-tooltip', '');

                } 
                AXISTooltip.initialise(trigger);
              } else {
                AXISDebug.output(3,"Basket: Could not find desktop trigger for notification tooltip.", container);
              }
            });
            break;
          default:
            // Text notification.
            notifications.each(function() {
              // Notification context.
              let notification = $(this);
              notification.wrap('<div class="text-notification-container"></div>');
            });
        }
      });
    } else {
      AXISDebug.output(2,"Basket: Could not find any instance of " +  expressSelectors()['basket']['summary-notifications-container'] + " in the DOM to display notifications", notifications);
    }
  } else {
    if (notificationContainers.length) {
      if (AXISDebug.level() > 3) {
        AXISDebug.output(1,"Basket: Cleaning up previous notifications");
      }
      // Clear previous notifications.
      notificationContainers.empty();
      // Reset summary severity state.
      summaryContainer.removeClass('alert warning');
    }
    
  }
}

function updateBasketItemCountDisplay(data) {
  let itemCount = (data.hasOwnProperty('basket-item-count') ? data['basket-item-count'] : false);
  // Check DOM if there are any elements to update.
  let itemCountDisplay = $('[' + expressSelectors()['basket']['item-count'] + ']');
  // If item count is provided.
  if (itemCount) {
    // If any exist.
    if (itemCountDisplay.length) {
      itemCountDisplay.text(itemCount);
      return {
        "item-count": itemCount,
        "display-element": itemCountDisplay
      }
    }
  }
  return {
    "success": false
  }
}

// Semi generic function for updating basket.
function updateDOM(basketContents) {
  //console.log("Attempting to update DOM with basket response.", basketContents);
  // Check if basket item count as been provided.
  updateBasketItemCountDisplay(basketContents);
  // Check if basket total value has been provided.
  let basketTotalValue = (basketContents.hasOwnProperty('basket-total-value') ? basketContents['basket-total-value'] : false);
  // If provided.
  if (basketTotalValue) {
    // Check dom if there are any elements to update.
    let totalValueDisplay = $('[' + expressSelectors()['basket']['total-value'] + ']');
    // If any exist.
    if (totalValueDisplay.length) {
      totalValueDisplay.html(basketTotalValue).text();
    }
  }

  let basketSummary = (basketContents.hasOwnProperty('popupContent') ? basketContents['popupContent'] : false);
  if (basketSummary) {
    //Update the basket section in the header with the updated basket contents
    $('[' + expressSelectors()['basket']['summary-container'] + ']').replaceWith(basketSummary);
  }

  // Re-initialise foundation inside of the basket summary container.
  $('[' + expressSelectors()['basket']['summary-container'] + ']').foundation();

  // Toggler instances.
  let togglers = $('[' + expressSelectors()['basket']['summary-container'] + ']').find('[data-toggler]');
  // Loop through togglers.
  if (togglers) {
    togglers.each(function() {
      // Grab context.
      let toggler = $(this);
      // Initialise.
      let init = AXISToggler.initialise(toggler);
    });
  }
  // Recently add popup.
  let recentlyAdded = (basketContents != undefined ? basketContents['recently-added'] : false);
  // Update DOM if recently added provided.
  if (recentlyAdded) {
    $('[' + expressSelectors()['basket']['summary-container'] + ']').append(recentlyAdded);
  }
  if ($('[' + expressSelectors()['basket']['summary-container'] + ']').not(".active")) {
    //If not on the checkout basket page.
    if (!$('#basket').length) {
      //triggerBasketPreview(true);
      //basketPreviewPosition();
      // Trigger recently added.
      // Had to add small timeout to allow for intro animation.
      setTimeout(() => {
        toggleRecentlyUpdated();
        // Assign position.
        setSummaryRecentlyAddedPosition();
      }, .1);
    }
  }
}

// Close recently updated popup.
function closeRecentlyUpdated() {
    // Get summary container.
    let container = $('[' + expressSelectors()['basket']['summary-container'] + ']');
    // Disable active state.
    container.removeClass('active');
    if (container.hasClass('active')) {
        return false;
    } else {
        return true;
    } 
}

var AXISBasket = $.AXISBasket = {
    initialiseAll: () => {
        return initialiseAll();
    },
    updateHeaderSummary: (data) => {
      return updateHeaderSummary(data);
    },
    updateBasketGen1: (data) => {
      return updateDOM(data);
    },
    updateBasketItemCountDisplay: (data) => {
      return updateBasketItemCountDisplay(data);
    }
}
  
export { AXISBasket };